







































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { EventModel } from "@/models/event";
import { ConstantDescriber } from '@/interfaces/Services';

@Component({})
export class Injection extends Vue {
  @Prop({ required: true })
  event!: EventModel;

  @Prop()
  disabled!: boolean;

  get formConfig() {
    const consts: ConstantDescriber = (this as any).apiConstants;
    return {
      meta: {
        bodyArea: {
          side: {
            label: this.$t("event.fields.side"),
            disabled: this.disabled,
            items: consts.event.bleeding.body_side.map(i => ({text: i.label, value: i.value}))
          },
          area: {
            label: this.$t("event.fields.area"),
            disabled: this.disabled,
            items: consts.event.bleeding.body_area.map(i => ({text: i.label, value: i.value}))
          }
        },
        type: {
          label: this.$t("event.fields.type"),
          disabled: this.disabled,
          items: consts.event.bleeding.type.map(i => ({text: i.label, value: i.value}))
        },
        customType: {
          label: this.$t("event.fields.customType"),
          disabled: this.disabled,
        },
        reason: {
          label: this.$t("event.fields.reason"),
          disabled: this.disabled,
          items:  consts.event.bleeding.reason.map(i => ({text: i.label, value: i.value}))
        },
        customReason: {
          label: this.$t("event.fields.customReason"),
          disabled: this.disabled,
        },
        intensity: {
          label: this.$t("event.fields.intensity"),
          disabled: this.disabled,
        }
      }
    };
  }
}
export default Injection;
